import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/(public)/error.tsx");
